import './App.css';
import Header from "./common/header/header";
import Main from "./common/main/main";

const App = (props) => {
    return [
        <div>
            <Header></Header>
            <Main></Main>
        </div>
    ];
};

export default App;
